(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
  typeof define === 'function' && define.amd ? define(['exports'], factory) :
  (factory((global['translator-client'] = {})));
}(this, (function (exports) { 'use strict';

  var toArray = function (arr) {
    return Array.isArray(arr) ? arr : Array.from(arr);
  };

  var axios = require('axios');

  var ctx = {
    client: '',
    namespaces: [],
    system: '',
    translations: {}
  };

  var escapeRegExp = function escapeRegExp(str) {
    return str.replace(/([.*+?^=!:${}()|[\]/\\])/g, '\\$1');
  };

  var hasPluralValue = function hasPluralValue(_ref) {
    var _ref2 = toArray(_ref),
        kv = _ref2[0],
        map = _ref2.slice(1);

    var plural = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    if (!kv || plural) return plural;
    return hasPluralValue(map, kv[1] > 1);
  };

  var getTranslationStr = function getTranslationStr(translations, key, map) {
    var pluralStr = translations[key + '_plural'];
    if (!pluralStr || !map.length) return translations[key];

    return hasPluralValue(map) ? pluralStr : translations[key];
  };

  var interpolate = function interpolate(_ref3) {
    var _ref4 = toArray(_ref3),
        kv = _ref4[0],
        map = _ref4.slice(1);

    var str = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    if (!kv || !str) return str;
    return interpolate(map, str.replace(new RegExp(escapeRegExp('{{' + kv[0] + '}}'), 'g'), kv[1]));
  };

  var init = function init(URL, system, locale, namespaces) {
    var client = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;

    if (!URL || !locale || !system) throw Error('URL, System & locale must be specified');

    ctx.client = client;
    ctx.namespaces = namespaces;
    ctx.system = system;

    return setTranslations(URL, locale);
  };

  var setTranslations = function setTranslations(URL, locale) {
    return axios(URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      data: JSON.stringify({
        client: ctx.client,
        locale: locale,
        namespaces: ctx.namespaces,
        system: ctx.system
      })
    }).then(function (res) {
      return ctx.translations = res.data;
    });
  };

  var translate = function translate(key) {
    var interpolation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var map = Object.entries(interpolation);
    return interpolate(map, getTranslationStr(ctx.translations, key, map)) || key;
  };

  var t = translate;

  exports.init = init;
  exports.translate = translate;
  exports.t = t;

  Object.defineProperty(exports, '__esModule', { value: true });

})));



//////////////////
// WEBPACK FOOTER
// ./node_modules/@billes/translator-client/dist/bundle.js
// module id = 11
// module chunks = 5